module.exports = __webpack_public_path__ + "static/media/person-dark.bec33717.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/person-dark.svg
// module id = 1184
// module chunks = 0